import React, { useContext, useState, useEffect } from 'react';
import Context from '../../context/Context';
import PrivateRoute from '../login/PrivateRoute/PrivateRoute';
import { Outlet, ScrollRestoration, useLocation } from 'react-router-dom';
import LoadingModal from '../../components/loadingModal/LoadingModal';
import SaveOrDeleteModal from '../../components/saveOrDeleteModal/SaveOrDeleteModal';
import { ToastContainer } from 'react-toastify';
import ConfirmDeleteActionModal from '../../components/saveOrDeleteModal/confirmDeleteAction/ConfirmDeleteAction';
import '../../index.css';
import TopBar from '../../components/topBar/TopBar';
import SideBar from '../../components/sideBar/SideBar';

const DashboardContent = () => {
	const location = useLocation();
	const [sidebarOpen, setSidebarOpen] = useState(false);
	const [isMobile, setIsMobile] = useState(false);

	// Handle screen size changes
	useEffect(() => {
		const checkScreenSize = () => {
			setIsMobile(window.innerWidth < 1024);
			if (window.innerWidth >= 1024) {
				setSidebarOpen(false); // Close mobile sidebar on desktop
			}
		};

		checkScreenSize();
		window.addEventListener('resize', checkScreenSize);
		return () => window.removeEventListener('resize', checkScreenSize);
	}, []);

	// Handle sidebar toggle
	const toggleSidebar = () => {
		setSidebarOpen(!sidebarOpen);
	};

	// Close sidebar when clicking outside on mobile
	const closeSidebar = () => {
		if (isMobile) {
			setSidebarOpen(false);
		}
	};

	const actionModalContext = useContext(Context);
	const { actionTitle, loadingValue, theItemToBeDeleted } = actionModalContext;

	const getBackgroundColor = () => {
		const whiteBackgroundPaths = [
			'/program-advantages',
			'/common-questions',
			'/create-page',
		];
		return whiteBackgroundPaths.includes(location.pathname)
			? 'bg-white'
			: 'bg-[#FFF5F8]';
	};

	return (
		<PrivateRoute>
			{/* Modals */}
			{theItemToBeDeleted && <ConfirmDeleteActionModal />}
			{actionTitle && <SaveOrDeleteModal />}
			{loadingValue && <LoadingModal />}

			{/* Toast Container */}
			<ToastContainer
				rtl
				draggable
				closeOnClick
				autoClose={2000}
				pauseOnFocusLoss
				position='top-center'
				newestOnTop={false}
				hideProgressBar={false}
				style={{ fontSize: '14px', color: '#000', whiteSpace: 'normal' }}
			/>

			{/* Top Bar */}
			<TopBar toggleSidebar={toggleSidebar} isMobile={isMobile} />

			{/* Main Layout */}
			{location.pathname !== '/' ? (
				<div className='flex min-h-screen pt-[70px] relative'>
					{/* Mobile Overlay */}
					{isMobile && sidebarOpen && (
						<div
							className='fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden'
							onClick={closeSidebar}
						/>
					)}

					{/* Sidebar */}
					<div
						className={`
						${isMobile ? 'fixed' : 'sticky'} 
						top-[70px] 
						z-50 
						transition-transform duration-300 ease-in-out
						${isMobile && !sidebarOpen ? 'translate-x-full' : 'translate-x-0'}
						${isMobile ? 'right-0' : ''}
					`}>
						<SideBar closeSidebar={closeSidebar} isMobile={isMobile} />
					</div>

					{/* Main Content */}
					<div
						className={`
						flex-1 
						min-h-screen 
						${getBackgroundColor()}
						${!isMobile ? 'ml-0' : ''}
						transition-all duration-300 ease-in-out
						overflow-x-hidden
					`}>
						<div>
							<ScrollRestoration />
							<Outlet />
						</div>
					</div>
				</div>
			) : (
				<div className='main-content pt-[70px]'>
					<Outlet />
				</div>
			)}
		</PrivateRoute>
	);
};

export default DashboardContent;
